import { SiriusBaseComponent } from 'sirius-framework';
import { Input, Output, EventEmitter, Component, TemplateRef, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'message-show',
  templateUrl: './message-show.component.html',
  styleUrls: ['./message-show.component.css']
})
export class MessageShowComponent extends SiriusBaseComponent<any> {
  @Input('MessageTitle') messageTitle: string;
  @Input('Message') message: string;
  @Output('OnMessageAccepted') onMessageAccepted = new EventEmitter<void>();
  @Input('ShowCancelButton') showCancelButton: boolean;

  @ViewChild("template") template: TemplateRef<any>;

  modalRef: BsModalRef;
  constructor(private modalService: BsModalService) {
    super();
  }

  OnInit() {
    
  }

  openModal() {
    this.modalRef = this.modalService.show(this.template);
  }

  onAccept() {
    this.onMessageAccepted.emit();
    this.close();
  }
  showPopup() {
    this.openModal();
  }

  close() {
    this.modalRef.hide();
  }

}
